import { WorkspaceMemberSelectField } from './WorkspaceMemberSelectField';

type AssignorSelectProps = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
};

export function AssignorSelect({
  value,
  onChange,
  error,
  disabled,
}: AssignorSelectProps) {
  return (
    <WorkspaceMemberSelectField
      name="task-assignor"
      label="Assignor"
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
    />
  );
}
